<template>
  <div class="bg-base-100 mt-2 space-y-4 p-4">
    <div
      class="flex items-end justify-between p-4 shadow transition-all hover:shadow-md"
    >
      <div>
        <div class="font-bold">Yêu cầu cập nhật cho chiến dịch</div>
        <div class="text-base-content/80">
          Kiểm tra các phiên bản có thể cập nhật cho toàn bộ chiến dịch
        </div>
      </div>
      <button
        class="btn btn-primary btn-outline"
        @click="openUpdateRequestModal"
      >
        Yêu cầu cập nhật
      </button>
    </div>
    <CampaignUpdateHistory :campaignId="campaignId" />
    <CampaignUpdateRequestModal
      ref="updateRequestModal"
      :campaignId="campaignId"
    />
  </div>
</template>

<script setup lang="ts">
import { router } from "@/router/router";
import { ref } from "vue";
import CampaignUpdateHistory from "./CampaignUpdateHistory.vue";
import CampaignUpdateRequestModal from "./CampaignUpdateRequestModal.vue";

const campaignId = router.currentRoute.value.params.campaign_id as string;

const updateRequestModal = ref<InstanceType<
  typeof CampaignUpdateRequestModal
> | null>(null);

const openUpdateRequestModal = () => {
  if (updateRequestModal.value?.modal) {
    updateRequestModal.value.modal.showModal();
  }
};
</script>
